var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gd-login',{staticClass:"bg-secondary",attrs:{"callback":_vm.callback}})
}
var staticRenderFns = []

export { render, staticRenderFns }